"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./FlyoutTemplate.css");
var Text_1 = require("player-common-controls/controls/Text");
var Panel_1 = require("player-layout-controls/controls/Panel");
var FlyoutTemplate = (function (_super) {
    __extends(FlyoutTemplate, _super);
    function FlyoutTemplate(props) {
        return _super.call(this, props) || this;
    }
    FlyoutTemplate.prototype.render = function () {
        var _a = this.props, backgroundColor = _a.backgroundColor, title = _a.title, header = _a.header, children = _a.children, footer = _a.footer, tag = _a.tag;
        return (React.createElement(Panel_1.Panel, { backgroundColor: backgroundColor, height: '100%' },
            React.createElement("div", { className: "p-flyouttemplate", "data-tag": tag },
                React.createElement(Panel_1.Panel, { paddingHorizontal: 'Large', paddingTop: 'Large', height: '60px' }, header.length ? header
                    : React.createElement(Text_1.Text, { text: title, size: 'Xlarge2', weight: 'Bold', wrapMode: "Ellipsis" })),
                React.createElement("div", { className: "body" }, children.length ? children : 'This is where your children goes'),
                React.createElement(Panel_1.Panel, { paddingHorizontal: 'Large', paddingVertical: 'Medium', height: '60px' }, footer.length ? footer : 'This is where your footer goes'))));
    };
    return FlyoutTemplate;
}(React.Component));
FlyoutTemplate.defaultProps = {
    backgroundColor: 'White',
    title: 'This is where your title goes',
    header: [],
    children: [],
    footer: [],
    tag: null
};
exports.FlyoutTemplate = FlyoutTemplate;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['common-composites'])
        csod.engine.controls['common-composites'] = {};
    csod.engine.controls['common-composites']['FlyoutTemplate'] = FlyoutTemplate;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["FlyoutTemplate"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-common-composites/controls/FlyoutTemplate/index.js
// module id = 938
// module chunks = 0